import { render, staticRenderFns } from "./MainSlideUpdate.vue?vue&type=template&id=37bc919d&"
import script from "./MainSlideUpdate.vue?vue&type=script&lang=js&"
export * from "./MainSlideUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports